var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtploader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 176,
    viewBox: "0 0 211 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M148.902 103.749L149.09 103.373L173.157 63.0674H98.332L86.3951 48.1438L181.929 48.3227L210.664 0L0 0.5606L106.354 175.39L134.906 127.067L122.404 103.749H148.902Z",
    fill: "#042b62",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtploader);
export default __webpack_public_path__ + "static/media/Otploader.9f4831c0aaed7fb3a5a5f0f6bfc6b532.svg";
export { ForwardRef as ReactComponent };